/**
 * Undo/redo for one route's Striping Plan list (spec 2026-10-14 Part A): snapshots of
 * the whole list. Record the list BEFORE each change; undo/redo trade the current list
 * for a snapshot. A history belongs to one route — recording for another starts over.
 */
export const MAX_HISTORY = 100;

const copy = (list) => (list || []).map((p) => ({ ...p }));

export const createHistory = (pathId = null) => ({ pathId, past: [], future: [] });

export const recordFor = (history, pathId, list) => {
  const h = history && history.pathId === pathId ? history : createHistory(pathId);
  return { pathId, past: [...h.past, copy(list)].slice(-MAX_HISTORY), future: [] };
};

export const undoHistory = (history, current) => {
  if (!history?.past.length) return null;
  return {
    history: {
      ...history,
      past: history.past.slice(0, -1),
      future: [copy(current), ...history.future],
    },
    list: history.past[history.past.length - 1],
  };
};

export const redoHistory = (history, current) => {
  if (!history?.future.length) return null;
  return {
    history: {
      ...history,
      past: [...history.past, copy(current)],
      future: history.future.slice(1),
    },
    list: history.future[0],
  };
};
